import { FC, useState } from "react";
import { ReactComponent as Exclamation } from "images/Exclamation.svg";
import { Link, useParams } from "react-router-dom";
import { ActionMenu } from "../ActionMenu/ActionMenu";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { SettingConnection } from "../SettingConnection/SettingConnection";
import Tooltip from "components-new/Tooltip";
import { uploadDocument } from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.thunks";
import { useAnimate } from "components-new/AnimateTemp/AnimateTemp";
import styles from "./TableItem.module.sass";
import cn from "classnames";
import { Menu } from "./Menu/Menu";
import Badge from "components-new/Badge";
import { connectNames, convertDate } from "helpers";
import ConfirmNavigate from "components/ConfirmNavigate";

interface TableItemProps {
	object: any;
	className: (id: number) => string;
}

export const TableItem: FC<TableItemProps> = ({ object, className: outlineClass }) => {
	const [modalWindow, setModalWindow] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const author = useAppSelector((state) => state.profile.profile.id);
	const { organizationId } = useParams();
	const [confirmAction, setConfirmAction] = useState<boolean>(false);

	const { className, handleClose } = useAnimate({
		unMount: styles.close,
		mount: styles.open,
		// mount:styles.close,
		// unMount:styles.open,
		delay: 200,
	});

	const documentUploadHandler = (files: FileList | null) => {
		if (author) dispatch(uploadDocument({ author, objectId: object.id, file: files![0] }));
	};

	const openModalWindow = () => {
		if (object.repeatable) setConfirmAction(true);
		else setModalWindow(true);
	};

	const confirmClick = () => {
		setModalWindow(true);
		setConfirmAction(false);
	};

	// enum Statuses {

	//     THIRD = "3.1 Формирование перечня объектов критической информационной инфраструктуры",
	//     FOURTH = "4.1 Формирование модели угроз",
	//     FIFTH = "5.1 Категорирование ОКИИ",
	//     SIXTH = "6.1 Подготовка и отправка результирующих документов",
	//     SEVENTH = "7.1 Присвоение ОКИИ реестровых номеров ФСТЭК и закрытие процесса"
	// }

	interface IStatuses {
		INITIAL: string;
		SECOND: string;
		THIRD: string;
		FOURTH: string;
		FIFTH: string;
		SIXTH: string;
		SEVENTH: string;

		[key: string]: any;
	}

	const Statuses: IStatuses = {
		INITIAL: "2.2 Создание реестра объектов",
		SECOND: "2.2 Создание реестра объектов",
		THIRD: "3.1 Формирование перечня объектов критической информационной инфраструктуры",
		FOURTH: "4.1 Формирование модели угроз",
		FIFTH: "5.1 Категорирование ОКИИ",
		SIXTH: "6.1 Подготовка и отправка результирующих документов",
		SEVENTH: "7.1 Присвоение ОКИИ реестровых номеров ФСТЭК и закрытие процесса",
	};

	const showDateAndTime = (): string => {
		const date = new Date(object.previousDate);
		const different = date.getTimezoneOffset();
		if (different < 0) date.setMinutes(date.getMinutes() + Math.abs(different));
		else date.setMinutes(date.getMinutes() - Math.abs(different));
		return `${date.toLocaleDateString()} ${date.toLocaleTimeString().slice(0, 5)}`;
	};

	return (
		<>
			{modalWindow && (
				<ModalWindow close={() => setModalWindow(false)}>
					<SettingConnection
						mode="object"
						close={() => setModalWindow(false)}
						targetId={object.id}
						title="Порядковый номер процесса"
						subtitle="Выберите бизнес-процессы"
					/>
				</ModalWindow>
			)}
			<ConfirmNavigate toggle={confirmAction} close={() => setConfirmAction(false)} clickHandler={confirmClick} />
			<tr className={cn(styles.row, className, outlineClass(object.id!))}>
				<td className={styles.item}>{object.code || "—"}</td>
				<td className={styles.item}>
					<div>{object.objectType.name || "—"}</div>
				</td>
				<td className={styles.item}>
					{object.statusKII ? (
						<div className={styles["sign-wrp"]}>
							<div className={styles.sign}></div>
						</div>
					) : (
						<div className={styles["sign-wrp"]}>—</div>
					)}
				</td>
				<td className={styles.item}>
					<div>{object.previousDate ? showDateAndTime() : "—"}</div>
				</td>
				<td className={styles.item}>
					{object.name ? (
						<div className={styles["item-wrp"]}>
							{!object.statusAdditional && (
								<div>
									<Tooltip
										delay={200}
										menu={
											<div className={styles.tooltip}>
												Отсутствует расширенная информация по объекту. Для заполнения данных - перейдите в объект
											</div>
										}
										color="themeWhite">
										<Exclamation className={styles.exclamation} />
									</Tooltip>
								</div>
							)}
							<Link
								className={styles.link}
								to={`/categorization/organizations/${organizationId}/steps/2.2/info/address`}
								state={{ id: object.id, name: object.name }}>
								{object.name}
							</Link>
						</div>
					) : (
						"—"
					)}
				</td>
				<td className={styles.item}>
					<div>
						<Badge type={object.repeatable ? "warn" : "success"}>
							{object.repeatable
								? `Повторная ${object.iterationsCount > 0 ? `(${object.iterationsCount})` : ""}`
								: "Первичная"}
						</Badge>
					</div>
				</td>
				<td className={styles.item}>{Statuses[object.stepProgress] || "—"}</td>
				<td className={styles.item}>
					<div>
						<pre className={styles.name}>{`${object.purpose}`}</pre>
					</div>
				</td>
				<td onClick={openModalWindow} className={cn(styles.item, styles.choice)}>
					<div>
						{object.bpList.length
							? object.bpList.map(
									(item: any, i: number) => `${item.sequence}${i + 1 === object.bpList.length ? "." : ", "}`,
							  )
							: "Выбрать бизнес-процессы..."}
					</div>
				</td>
				<td className={styles.item}>
					<ActionMenu timer={handleClose} className={styles.menu} obj={object} />
				</td>
				<td className={styles.item}>{object.code || "—"}</td>
				<td className={styles.item}>
					<div>
						{object.responsible.id ? (
							<Link className={styles.link} to={`/employee/${object.responsible.id}`}>
								{object.responsible.firstName} {object.responsible.middleName} {object.responsible.lastName}
							</Link>
						) : (
							"—"
						)}
					</div>
				</td>
				<td className={styles.item}>
					<div>{object.ownershipType.name}</div>
				</td>
				<td className={cn(styles.item, styles.docItem)}>
					{object.document?.id ? (
						<Menu className={styles.docMenu} object={object} />
					) : (
						<>
							<label htmlFor={`uploadDoc-${object.id}`} className={styles.link}>
								Добавить документ
							</label>
							<input
								onChange={(e) => documentUploadHandler(e.target.files)}
								type="file"
								id={`uploadDoc-${object.id}`}
								className="none"
								accept=".docx, .pdf, .rtf"
							/>
						</>
					)}
				</td>
				<td className={styles.item}>{object.activityArea.name}</td>
				<td className={styles.item}>
					{object.creator?.id ? (
						<Link className={styles.link} to={`/user/${object.creator.id}`}>
							{connectNames(object.creator)}
						</Link>
					) : (
						"—"
					)}
				</td>
				<td className={styles.item}>
					{object.createdAt ? `${convertDate(object.createdAt.split(" ")[0])} ${object.createdAt.split(" ")[1]}` : "—"}
				</td>
				<td className={styles.item}>
					{object.lastAuthor?.id ? (
						<Link className={styles.link} to={`/user/${object.lastAuthor.id}`}>
							{connectNames(object.lastAuthor)}
						</Link>
					) : (
						"—"
					)}
				</td>

				<td className={styles.item}>
					<ActionMenu timer={handleClose} className={styles.menu} obj={object} />
				</td>
			</tr>
		</>
	);
};
